import React, { useState } from 'react';
import { PRODUCTPAGE } from '../API/Config';
import { useEffect } from 'react';
import { useLocation, Link } from 'react-router-dom';
import Header from '../Layouts/Header';
import Footer from '../Layouts/Footer';
import bgImage from '../Assets/Images/ProductBg.png';
import { FaArrowDown } from 'react-icons/fa';
import CircularText from '../Components/CircularText';
import { motion, AnimatePresence } from 'framer-motion';
import { TbBulb } from "react-icons/tb";
import { IoShieldCheckmarkOutline } from "react-icons/io5";
import { GiSnowflake1 } from "react-icons/gi";
import { LuUserRound } from "react-icons/lu";
import SmartPOS from '../Assets/Images/SmartPOS.jpg'
import ERPLite from '../Assets/Images/ERPLite.jpg'
import Client360CRM from '../Assets/Images/Client360CRM.png'
import SchoolERP from '../Assets/Images/SchoolERP.png'
import TradingERP from '../Assets/Images/TradingERP.webp'
import ECommerce from '../Assets/Images/ECommerce.png'
import ConstructionManagement from '../Assets/Images/ConstructionManagement.jpg'
import ServiceProvider from '../Assets/Images/ServiceProvider.jpg'
import EquipmentMarketplace from '../Assets/Images/EquipmentMarketplace.jpg'
import LawServiceProvider from '../Assets/Images/Law-ServiceProvider.jpg'
import TradeWith from '../Assets/Images/TradeWith.jpeg'
import PeopleTracking from '../Assets/Images/PeopleTracking.jpg'
import ValorPay from '../Assets/Images/ValorPay.jpg'
import CargoServiceApp from '../Assets/Images/CargoServiceApp.jpg'
import TaskManagement from '../Assets/Images/TaskManagement.jpg'
import ProductCard from '../Components/ProductCard/ProductCard';
import ProductResponsive from '../Components/ProductCard/ProductResponsive'
// import ScrollVelocity from '../Components/ScrollVelocity'
import AOS from 'aos';
import 'aos/dist/aos.css';

// Product Image 
import ERPImage from '../Assets/Images/ERP-Software.jpeg'
import ClothingEcommerce from '../Assets/Images/Clothing-Ecommerce.jpeg'
import HRManagement from '../Assets/Images/HrManagement.jpeg'
import AutoFinanceImage from '../Assets/Images/AutoFinance.jpeg'
import LogisticSolutionImage from '../Assets/Images/LogisticSolution.jpeg'
import BillingSoftwareImage from '../Assets/Images/BillingSoftware.jpeg'


const initialItems = [
  {
    id: 1,
    imageUrl: SmartPOS,
    title: 'SmartPOS',
    description: 'A powerful POS system for retail businesses.',
  },
  {
    id: 2,
    imageUrl: ERPLite,
    title: 'ERP Lite',
    description: 'Lightweight ERP tailored for small and medium enterprises.',
  },
  {
    id: 3,
    imageUrl: Client360CRM,
    title: 'Client360 CRM',
    description: 'A complete CRM to manage customer relationships and pipelines.',
  },
  {
    id: 4,
    imageUrl: SchoolERP,
    title: 'School ERP',
    description: 'Manage school operations including attendance, fees, and academics.',
  },
  {
    id: 5,
    imageUrl: TradingERP,
    title: 'Trading ERP',
    description: 'ERP solution designed specifically for trading and inventory businesses.',
  },
  {
    id: 6,
    imageUrl: ECommerce,
    title: 'E-Commerce',
    description: 'Robust platform to launch and manage your online store.',
  },
  {
    id: 7,
    imageUrl: ConstructionManagement,
    title: 'Construction Management',
    description: 'Track and manage construction site workflows and materials.',
  },
  {
    id: 8,
    imageUrl: ServiceProvider,
    title: 'Service Provider',
    description: 'Customizable tools for businesses offering on-site or remote services.',
  },
  {
    id: 9,
    imageUrl: EquipmentMarketplace,
    title: 'Equipment Marketplace',
    description: 'Buy, sell, or rent industrial and commercial equipment online.',
  },
  {
    id: 10,
    imageUrl: LawServiceProvider,
    title: 'Law-Service Provider',
    description: 'Legal case and document management for law firms and attorneys.',
  },
  {
    id: 11,
    imageUrl: TradeWith,
    title: 'Trade With',
    description: 'Marketplace platform to connect traders and vendors across sectors.',
  },
  {
    id: 12,
    imageUrl: PeopleTracking,
    title: 'People Tracking',
    description: 'Track staff movement, attendance, and real-time location for safety.',
  },
  {
    id: 13,
    imageUrl: ValorPay,
    title: 'Valor Pay',
    description: 'A secure and fast digital wallet for seamless transactions.',
  },
  {
    id: 14,
    imageUrl: CargoServiceApp,
    title: 'Cargo Service App',
    description: 'Manage deliveries, drivers, and cargo logistics with ease.',
  },
  {
    id: 15,
    imageUrl: TaskManagement,
    title: 'Task Management',
    description: 'Organize, assign, and track tasks across teams and departments.',
  },
];

const featureCardsData = [
  {
    id: 1,
    title: 'Core HR 360',
    imageSrc: HRManagement,
    imageAlt: 'Core HR 360 Dashboard',
    tag: 'HR Management',
    description:
      'Complete HRMS solution for employee management, payroll, attendance, leave tracking, and recruitment automation.',
    features: [
      { title: 'Attendance & Leave', description: 'Automated biometric tracking and leave request workflows.' },
      { title: 'Payroll Processing', description: 'One-click salary calculation with tax compliance.' },
      { title: 'Performance Management', description: 'Set KPIs, track goals, and conduct regular appraisals.' }
    ],
    buttonText: 'See all features',
    link: '/core-hr-360'
  },

  {
    id: 2,
    title: 'Clothing Ecommerce',
    imageSrc: ClothingEcommerce,
    imageAlt: 'Clothing Ecommerce Platform',
    tag: 'Ecommerce Solution',
    description:
      'Online clothing store management with inventory tracking, orders, payments, and customer management.',
    features: [
      { title: 'Multi-variant Support', description: 'Easily manage products with different sizes, colors, and materials.' },
      { title: 'Secure Payment Gateway', description: 'Integrated checkout with UPI, cards, and net banking support.' },
      { title: 'Inventory Sync', description: 'Real-time stock updates to prevent overselling.' }
    ],
    buttonText: 'See all features',
    link: '/clothing-ecommerce'
  },

  {
    id: 3,
    title: 'Finance Software',
    imageSrc: AutoFinanceImage,
    imageAlt: 'Auto Finance Dashboard',
    tag: 'Finance Management',
    description:
      'Vehicle loan and EMI management software with customer tracking and payment collection system.',
    features: [
      { title: 'EMI Scheduling', description: 'Automated loan amortization and EMI calculation.' },
      { title: 'Collection Tracking', description: 'Monitor pending dues and field recovery agent assignments.' },
      { title: 'Credit Assessment', description: 'Built-in tools to evaluate applicant creditworthiness.' }
    ],
    buttonText: 'See all features',
    link: '/auto-finance'
  },

  {
    id: 4,
    title: 'Billing Software',
    imageSrc: BillingSoftwareImage,
    imageAlt: 'Billing Software Dashboard',
    tag: 'Billing System',
    description:
      'GST billing, invoice generation, accounting, and payment tracking software for businesses.',
    features: [
      { title: 'GST Compliance', description: 'Generate GSTR reports and e-Way bills instantly.' },
      { title: 'Custom Invoices', description: 'Professional invoice templates with your brand logo.' },
      { title: 'Expense Tracking', description: 'Monitor daily expenses and categorize business outflows.' }
    ],
    buttonText: 'See all features',
    link: '/billing-software'
  },

  {
    id: 5,
    title: 'Logistics Management',
    imageSrc: LogisticSolutionImage,
    imageAlt: 'Logistics Management System',
    tag: 'Logistics Solution',
    description:
      'Shipment tracking, warehouse management, transportation monitoring, and delivery optimization software.',
    features: [
      { title: 'Live Tracking', description: 'Real-time GPS tracking for delivery fleets and shipments.' },
      { title: 'Route Optimization', description: 'AI-driven route planning to save fuel and time.' },
      { title: 'Proof of Delivery', description: 'Digital signatures and photo capture upon delivery.' }
    ],
    buttonText: 'See all features',
    link: '/logistics-management'
  },

];


const GridItem = ({ item }) => {
  const [isHovered, setIsHovered] = useState(false);
  // const velocity = 50;
  const routeLocation = useLocation();



  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  AOS.init({
    duration: 1000,
    offset: 120,
    once: true, // run only once
  });



  useEffect(() => {
    const hash = routeLocation.hash;
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 200);
      }
    }
  }, [routeLocation]);


  return (
    <motion.div
      className="mb-4 break-inside-avoid relative cursor-pointer"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      whileHover={{ y: -5 }}
      transition={{ type: 'spring', stiffness: 300 }}
    >
      {/* Image */}
      <img
        src={item.imageUrl}
        alt={item.title}
        className="w-full h-auto rounded-xl shadow-lg"
        onError={(e) => {
          e.target.onerror = null;
          e.target.src = 'https://placehold.co/400x300/fecaca/333333?text=Image+Not+Found';
        }}
      />

      {/* Always visible title at top */}
      <div className="absolute top-0 left-0 w-full bg-[#00000045] rounded-t-xl">
        <p className="text-white font-semibold text-sm truncate py-1 px-4">
          {item.title}
        </p>
      </div>

      {/* Description shown only on hover */}
      <AnimatePresence>
        {isHovered && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="absolute inset-0 rounded-xl overflow-hidden"
          >
            <div className="absolute bottom-0 left-0 w-full bg-black/70 px-4 py-3 rounded-b-xl">
              <p className="text-white font-normal text-sm">{item.description}</p>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.div>
  );
};


const MasonryGrid = ({ items }) => {
  return (
    <div className="columns-1 gap-6 sm:columns-2 lg:columns-3 xl:columns-4" style={{ columnWidth: '280px' }}>
      {items.map((item) => (
        <GridItem key={item.id} item={item} />
      ))}
    </div>
  );
};

const Products = () => {
  const handleScroll = () => {
    const section = document.getElementById('scrollDown');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const [formData, setFormData] = useState({
    fullname: '',
    email: '',
    phonenumber: '',
    subject: '',
    producttype: '',
    message: '',
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  
  const routeLocation = useLocation();
  useEffect(() => {
    if (routeLocation.hash === '#DemoForm') {
      setTimeout(() => {
        document.getElementById('DemoForm')?.scrollIntoView({ behavior: 'smooth' });
      }, 300);
    }
  }, [routeLocation]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const response = await fetch(PRODUCTPAGE, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });

      const result = await response.json();

      if (response.ok) {
        setSuccess('Demo request submitted successfully!');
        setFormData({
          fullname: '',
          email: '',
          phonenumber: '',
          subject: '',
          producttype: '',
          message: '',
        });
      } else {
        setError(result.message || 'Failed to submit demo request.');
      }
    } catch (err) {
      setError('Error submitting form. Please try again later.');
      console.error('API Error:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className="flex flex-col min-h-screen bg-black text-white">
        <Header />

        {/* Hero Section - Above code */}
        <div className="relative min-h-screen flex flex-col justify-center items-center text-white"
          style={{
            backgroundImage: `url(${bgImage})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundAttachment: 'fixed',
          }}
        >
          {/* Dark Overlay */}
          <div className="absolute inset-0 bg-black opacity-65"></div>

          {/* Content */}
          <div className="relative z-10 text-center px-4 md:px-0 pb-32 space-y-4">
            <p className="text-xl md:text-2xl font-semibold tracking-wider">Products</p>
            <div className="mx-auto w-24 h-1 bg-white"></div>
            <h1 className="text-4xl md:text-6xl font-bold leading-tight">OUR FEATURED PRODUCTS</h1>
            <h2 className="text-lg md:text-2xl font-normal mt-2">Turning uncertainty into opportunity</h2>
          </div>

          {/* Scroll Down */}
          <div className="relative flex items-center justify-center mt-10">
            <div onClick={handleScroll} className="absolute top-0 left-0 w-full h-full flex items-center justify-center">
              <CircularText text="VIVEKASOFTEK @ EXPLORE " spinDuration={20} />
            </div>
            <div className="z-10 flex items-center justify-center">
              <button onClick={handleScroll}>
                <FaArrowDown size={28} className="text-white" />
              </button>
            </div>
          </div>
        </div>

        {/* Our Approach Section */}
        <div className="text-white py-16 px-6">
          <div className="text-center mb-12">
            <h2 className="text-sm font-semibold tracking-widest text-white uppercase mb-2">Our Approach</h2>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-4 gap-10 max-w-6xl mx-auto text-center">
            {/* Innovation-driven */}
            <div className="flex flex-col items-center">
              <div className="text-5xl text-[#3575de] mb-4">
                <TbBulb />
              </div>
              <p className="text-lg font-medium">Innovation-driven</p>
            </div>

            {/* Resilient */}
            <div className="flex flex-col items-center">
              <div className="text-5xl text-[#3575de] mb-4">
                <IoShieldCheckmarkOutline />

              </div>
              <p className="text-lg font-medium">Resilient</p>
            </div>

            {/* Agile */}
            <div className="flex flex-col items-center">
              <div className="text-5xl text-[#3575de] mb-4">
                <GiSnowflake1 />
              </div>
              <p className="text-lg font-medium">Agile</p>
            </div>

            {/* Experience-focused */}
            <div className="flex flex-col items-center">
              <div className="text-5xl text-[#3575de] mb-4">
                <LuUserRound />
              </div>
              <p className="text-lg font-medium">Experience-focused</p>
            </div>
          </div>
        </div>

        <div id="scrollDown" ></div>
        <div
          className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 flex flex-col items-center justify-center"
        >
          <div className="text-3xl sm:text-4xl font-bold text-center text-white mt-10 mb-8 tracking-wide">
            Our Successful Projects
            <div className="h-1 w-24 bg-blue-600 mx-auto mt-5 rounded-full"></div>
          </div>

          {/* Ensure ProductCard renders centered content or is wrapped accordingly */}
          {/* <div className="w-full justify-center">
            <div className="hidden lg:block">
              <ProductCard />
            </div>

            <div className="block lg:hidden">
              <ProductResponsive />
            </div>
          </div> */}



          {featureCardsData.map((card, index) => (
            <div key={card.id} className='mt-10 w-full max-w-6xl'>
              <div className='bg-[#162840] w-full rounded-2xl p-10 text-white shadow-lg'>

                <div className='grid grid-cols-1 lg:grid-cols-2 gap-10 items-center'>

                  {/* Left Column - Image */}
                  <div className={`flex justify-center ${index % 2 !== 0 ? 'lg:order-last' : ''}`}>
                    <img
                      src={card.imageSrc}
                      alt={card.imageAlt}
                      className='rounded-2xl w-full max-w-md lg:max-w-full shadow-xl'
                    />
                  </div>

                  {/* Right Column - Content */}
                  <div className={`space-y-6 ${index % 2 !== 0 ? 'lg:order-first' : ''}`}>
                    <div className='inline-block px-4 py-1.5 bg-blue-600/20 text-blue-400 text-sm font-medium rounded-full'>
                      {card.tag}
                    </div>

                    <h2 className='text-4xl font-semibold leading-tight'>
                      {card.titleMain || card.title} <span className='text-blue-400'>{card.titleHighlight || ''}</span>
                    </h2>

                    <p className='text-gray-300 text-base font-medium'>
                      {card.description}
                    </p>

                    {/* Feature List */}
                    {card.features && card.features.length > 0 && (
                      <div className='space-y-4'>
                        {card.features.map((feature, idx) => (
                          <div key={idx} className='flex items-start gap-3'>
                            <div className='w-6 h-6 rounded-full bg-green-500/20 flex items-center justify-center flex-shrink-0 mt-0.5'>
                              ✓
                            </div>
                            <div>
                              <h4 className='font-semibold'>{feature.title}</h4>
                              <p className='text-gray-400 text-sm font-medium'>{feature.description}</p>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}


                    {/* See All Features Button */}
                    {card.link && card.link !== '#' ? (
                      <Link to={card.link}>
                        <button className='mt-6 px-8 py-3.5 bg-white text-[#162840] font-semibold rounded-xl hover:bg-gray-100 transition-all duration-200 flex items-center gap-2 group'>
                          {card.buttonText}
                          <span className='group-hover:translate-x-1 transition-transform'>→</span>
                        </button>
                      </Link>
                    ) : (
                      <button className='mt-6 px-8 py-3.5 bg-white text-[#162840] font-semibold rounded-xl hover:bg-gray-100 transition-all duration-200 flex items-center gap-2 group'>
                        {card.buttonText}
                        <span className='group-hover:translate-x-1 transition-transform'>→</span>
                      </button>
                    )}
                  </div>

                </div>
              </div>
            </div>
          ))}



        </div>




        {/* Product Section */}
        {/* <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <MasonryGrid items={initialItems} />
        </div> */}


        <div id="DemoForm" className='bg-white text-black p-8 px-6 md:px-12'>
          <div className="flex items-center justify-center min-h-screen px-4 py-10">
            <form
              className="w-full max-w-4xl mx-auto rounded-xl"
              onSubmit={handleSubmit}
            >
              <h2 className="text-4xl font-semibold text-center mb-8">Request For A Demo</h2>

              {/* Error/Success Messages */}
              {error && <p className="text-red-500 text-center mb-4">{error}</p>}
              {success && <p className="text-green-500 text-center mb-4">{success}</p>}

              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {/* Full Name */}
                <div>
                  <label className="block text-sm font-medium mb-1">Full Name</label>
                  <input
                    type="text"
                    name="fullname"
                    value={formData.fullname}
                    onChange={handleChange}
                    placeholder="Enter your full name"
                    className="w-full px-4 py-2 font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    required
                  />
                </div>

                {/* Email */}
                <div>
                  <label className="block text-sm font-medium mb-1">Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="Enter your email"
                    className="w-full px-4 py-2 font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    required
                  />
                </div>

                {/* Phone Number */}
                <div>
                  <label className="block text-sm font-medium mb-1">Phone Number</label>
                  <input
                    type="tel"
                    name="phonenumber"
                    value={formData.phonenumber}
                    onChange={handleChange}
                    placeholder="Enter your phone number"
                    className="w-full px-4 py-2 font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    required
                  />
                </div>

                {/* Subject */}
                <div>
                  <label className="block text-sm font-medium mb-1">Subject</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    placeholder="Subject"
                    className="w-full px-4 py-2 font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    required
                  />
                </div>

                {/* Product Type */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium mb-1">Product Type</label>
                  <input
                    type="text"
                    name="producttype"
                    value={formData.producttype}
                    onChange={handleChange}
                    placeholder="Product Type"
                    className="w-full px-4 py-2 font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                    required
                  />
                </div>

                {/* Message */}
                <div className="md:col-span-2">
                  <label className="block text-sm font-medium mb-1">Message</label>
                  <textarea
                    name="message"
                    value={formData.message}
                    onChange={handleChange}
                    placeholder="Write your message"
                    rows={4}
                    className="w-full px-4 py-2 font-medium border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-black"
                  />
                </div>
              </div>

              {/* Submit Button */}
              <div className="text-right mt-6">
                <button
                  type="submit"
                  className="bg-black text-white font-medium px-8 py-2 rounded-full hover:bg-gray-800 transition"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Request'}
                </button>
              </div>
            </form>
          </div>
        </div>



        <Footer />
      </div>

    </>
  );
};

export default Products;
